import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

/**
 * Shared horizontal rhythm for landing sections.
 *
 * Deliberately has no max-width: sections run the full width of the viewport at
 * every size. This only owns the side gutters, so every section starts and ends
 * its content on the same line as its neighbours — which is the thing the old
 * landing got wrong by repeating slightly different `max-w-*` values per file.
 */
export function SectionShell({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return <div className={cn('w-full px-2 md:px-4', className)}>{children}</div>;
}

/**
 * Vertical rhythm. Sections in the design breathe a lot on desktop and compress
 * hard on mobile; this keeps that ratio consistent rather than per-section.
 */
export function SectionBlock({
  children,
  className,
  id,
  tone = 'bg',
}: {
  children: ReactNode;
  className?: string;
  id?: string;
  tone?: 'bg' | 'surface';
}) {
  return (
    <section
      id={id}
      className={cn(
        'w-full py-12 md:py-20 lg:py-28',
        tone === 'bg' && 'bg-marketing-bg',
        tone === 'surface' && 'bg-marketing-surface',
        className
      )}
    >
      {children}
    </section>
  );
}
